import LegalPage from "@/components/shared/LegalPage";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      pageTestId="wc-privacy-policy"
      documentTitle="Privacy Policy"
      title="Privacy Policy"
      lastUpdated="July 2026"
      intro={[
        'WinCampaign ("WinCampaign", "we", "our", or "us") respects your privacy and is committed to protecting your personal information.',
        "This Privacy Policy explains how we collect, use, disclose, and protect your information when you visit our website, purchase our services, or interact with our business.",
        "By using this website, you agree to this Privacy Policy.",
      ]}
      sections={[
        {
          heading: "Information We Collect",
          paragraphs: ["We may collect information including:"],
          bullets: [
            "Full Name",
            "Email Address",
            "Phone Number",
            "Business Name",
            "Website",
            "Social Media Profiles",
            "Billing Information",
            "Payment Information (processed securely through third-party payment providers)",
            "IP Address",
            "Browser Information",
            "Device Information",
            "Information submitted through forms",
            "Information provided during onboarding",
          ],
        },
        {
          heading: "How We Use Your Information",
          paragraphs: ["Your information may be used to:"],
          bullets: [
            "Deliver our services",
            "Process payments",
            "Create your account",
            "Provide customer support",
            "Improve our products and services",
            "Communicate updates",
            "Send educational content",
            "Send marketing emails (you may unsubscribe at any time)",
            "Improve website performance",
            "Prevent fraud",
          ],
        },
        {
          heading: "Payment Processing",
          paragraphs: [
            "Payments are processed securely through trusted third-party payment processors.",
            "WinCampaign does not store your complete credit card information.",
          ],
        },
        {
          heading: "Cookies",
          paragraphs: ["Our website may use cookies to:"],
          bullets: [
            "Improve user experience",
            "Remember preferences",
            "Analyze website traffic",
            "Improve website performance",
          ],
        },
        {
          paragraphs: ["You may disable cookies through your browser settings."],
        },
        {
          heading: "Third-Party Services",
          paragraphs: ["We may use trusted providers including:"],
          bullets: [
            "Stripe",
            "SureCart",
            "Google Workspace",
            "Email marketing platforms",
            "CRM platforms",
            "Analytics providers",
            "Social media platforms",
          ],
        },
        {
          paragraphs: [
            "These providers maintain their own privacy policies.",
          ],
        },
        {
          heading: "Data Security",
          paragraphs: [
            "We implement commercially reasonable security measures to protect your personal information.",
            "However, no online transmission or storage system is completely secure.",
          ],
        },
        {
          heading: "Your Rights",
          paragraphs: ["You may request to:"],
          bullets: [
            "Access your information",
            "Correct inaccurate information",
            "Request deletion where permitted by law",
            "Unsubscribe from marketing communications",
          ],
        },
        {
          paragraphs: ["Requests may be sent to: support@wincampaign.io"],
        },
        {
          heading: "Policy Updates",
          paragraphs: [
            "We may update this Privacy Policy from time to time.",
            "Changes become effective immediately upon posting.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: ["Questions? support@wincampaign.io"],
        },
      ]}
    />
  );
}
